"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentType = void 0;
var ComponentType;
(function (ComponentType) {
    ComponentType["LIGHT"] = "light";
    ComponentType["INVERTER"] = "inverter";
    ComponentType["VENT_FAN"] = "ventfan";
    ComponentType["FAN"] = "fan";
    ComponentType["TANK"] = "tank";
    ComponentType["SHORE_POWER"] = "shorepower";
    ComponentType["BATTERY"] = "battery";
    ComponentType["TIRE"] = "tire";
    ComponentType["WINDOW_SHADE"] = "windowshade";
    ComponentType["AWNING"] = "awning";
    ComponentType["HVAC"] = "hvac";
    ComponentType["MODE"] = "mode";
    ComponentType["V1_AWNING"] = "v1awning";
    ComponentType["DUMB_AWNING"] = "dumbawning";
    ComponentType["SKYLIGHT"] = "skylight";
})(ComponentType = exports.ComponentType || (exports.ComponentType = {}));
//# sourceMappingURL=ComponentType.js.map